// src/admin/AdminDashboard.jsx
import React, { useEffect, useState } from "react";
import "./css/admin.css";
import { Skeleton } from "antd";
import { useNavigate } from "react-router-dom";
import { toastError } from "../utils/toast";
import { fetchDashboardStats } from "../api/dashboardApi";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const loadStats = async () => {
    setLoading(true);
    try {
      const data = await fetchDashboardStats();
      setStats(data);
    } catch (err) {
      toastError(err?.message || "Failed to load stats");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStats();
  }, []);

  // Admin-only quick actions
  const quickActions = [
    { label: "Add Lawyer", type: "primary", onClick: () => navigate("/admin/lawyers") },
    { label: "Add Blog", type: "outline", onClick: () => navigate("/admin/blogs") },
    { label: "View Query Forms", type: "outline", onClick: () => navigate("/admin/queries") },
    { label: "Add New Service", type: "outline", onClick: () => navigate("/admin/services") },
  ];

  const StatSkeletonCard = () => (
    <div className="stat-card">
      <Skeleton.Input active style={{ width: 140, marginBottom: 8 }} />
      <Skeleton.Input active style={{ width: 80, height: 32 }} />
    </div>
  );

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const displayName = user?.name || "User";
  const displayRole = user?.role ? user.role.charAt(0).toUpperCase() + user.role.slice(1) : "";

  return (
    <>
      <h1 className="dash-title">
        Dashboard <span className="dash-user">– {displayName} ({displayRole})</span>
      </h1>

      <div className="dashboard-container">
        {/* Stats section */}
        {loading || !stats ? (
          <div className="stats-grid">
            {Array.from({ length: 5 }).map((_, i) => (
              <StatSkeletonCard key={i} />
            ))}
          </div>
        ) : (
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-label">Total Lawyers</div>
              <div className="stat-value">{stats.lawyers}</div>
            </div>
            <div className="stat-card">
              <div className="stat-label">Active Lawyers</div>
              <div className="stat-value">{stats.active_lawyers}</div>
            </div>
            <div className="stat-card">
              <div className="stat-label">Total Corporate Clients</div>
              <div className="stat-value">{stats.firms}</div>
            </div>
            <div className="stat-card">
              <div className="stat-label">Total Blogs</div>
              <div className="stat-value">{stats.blogs}</div>
            </div>
            <div className="stat-card">
              <div className="stat-label">Total Case Studies</div>
              <div className="stat-value">{stats.cases}</div>
            </div>
          </div>
        )}

        {/* Quick actions */}
        <aside className="quick-actions">
          <h3>Quick Actions</h3>
          {loading || !stats ? (
            <>
              <Skeleton.Button active block style={{ height: 40, marginBottom: 10 }} />
              <Skeleton.Button active block style={{ height: 40, marginBottom: 10 }} />
              <Skeleton.Button active block style={{ height: 40, marginBottom: 10 }} />
              <Skeleton.Button active block style={{ height: 40 }} />
            </>
          ) : (
            quickActions.map((action) => (
              <button
                key={action.label}
                className={`qa-btn ${action.type}`}
                onClick={action.onClick}
              >
                {action.label}
              </button>
            ))
          )}
        </aside>
      </div>
    </>
  );
}
